import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import { alphaNumeric } from "lib/propTypes";

export const tabShape = PropTypes.shape({
    text: PropTypes.string,
    icon: PropTypes.node,
    value: PropTypes.number,
    url: PropTypes.string,
});

export default function TabList({
    className,
    defaultTab,
    handleTabChange,
    requireActiveTab,
    tabs,
}) {
    const [activeTab, setActiveTab] = useState(defaultTab || (requireActiveTab && tabs[0].text));

    useEffect(() => {
        setActiveTab(defaultTab);
    }, [defaultTab]);

    function onClickTab(event) {
        event.preventDefault();

        const tab = tabs[event.currentTarget.dataset.tab];
        if (tab.text === activeTab || tab.value === activeTab) {
            return;
        }

        const defer = () => setActiveTab(tab.text);

        if (handleTabChange(tab, defer) !== false) {
            defer();
        }
    }

    const nodes = tabs.map(({ text, badge, icon, value }, idx) => {
        const classes = classNames("tab-list__tab", {
            "tab-list__tab--active": activeTab === text || activeTab === value,
        });

        let badgeNode;
        if (badge) {
            badgeNode = <span className="tab-list__badge">{badge}</span>;
        }

        return (
            <div key={text} className={classes}>
                <a href="#" className="tab-list__link" data-tab={idx} onClick={onClickTab}>
                    {text}
                    {badgeNode}
                </a>
                {icon}
            </div>
        );
    });

    const classes = classNames("tab-list", className);
    return <nav className={classes}>{nodes}</nav>;
}

TabList.propTypes = {
    className: PropTypes.string,
    defaultTab: alphaNumeric,
    handleTabChange: PropTypes.func.isRequired,
    requireActiveTab: PropTypes.bool,
    tabs: PropTypes.arrayOf(tabShape).isRequired,
};

TabList.defaultProps = {
    className: null,
    defaultTab: null,
    requireActiveTab: true,
};
